/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Type_Deep_Tissue_Massage_TermsInputs */

const en_service_type_deep_tissue_massage_terms = /** @type {(inputs: Service_Type_Deep_Tissue_Massage_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`deep tissue, massage`)
};

const pl_service_type_deep_tissue_massage_terms = /** @type {(inputs: Service_Type_Deep_Tissue_Massage_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`masaż głęboki, deep tissue, masaż`)
};

/**
* | output |
* | --- |
* | "deep tissue, massage" |
*
* @param {Service_Type_Deep_Tissue_Massage_TermsInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_type_deep_tissue_massage_terms = /** @type {((inputs?: Service_Type_Deep_Tissue_Massage_TermsInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Type_Deep_Tissue_Massage_TermsInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_service_type_deep_tissue_massage_terms(inputs)
	return en_service_type_deep_tissue_massage_terms(inputs)
});